import {
    AnimationBaseController,
    GameRandom,
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { GameLogic } from "../../../Logic/GameLogic";
import { DBPlayerController } from "./DBPlayerController";

export interface IPlayerInnerControllerOptions {
}

export class PlayerInnerController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IPlayerInnerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("PlayerInnerController");
        console.log('PlayerInnerController');

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            childControllers: {
                DBPlayer: {
                    controller: DBPlayerController,
                    model: this.$model,
                    options: {
                        gender: this.$model.playerGender
                    }
                }
            },
        };
    }

    protected onInitialize(): void {
        this.x = 1000
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

